// src/router/index.js
// All route definitions for the Blything app

import { createRouter, createWebHistory } from 'vue-router';
import { authGuard } from '@auth0/auth0-vue';
import { authGuardBeforeEach } from './guards';

import LandingPage from '@/pages/LandingPage.vue';
import HomePage from '@/pages/HomePage.vue';
import AdminPage from '@/pages/AdminPage.vue';
import SnailMailPage from '@/pages/SnailMail.vue';
import NotFoundPage from '@/pages/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    name: 'landing',
    component: LandingPage,
    meta: { title: 'Blything | Welcome' },
  },
  {
    path: '/home',
    name: 'home',
    component: HomePage,
    beforeEnter: authGuard,
    meta: { title: 'Blything | Home' },
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminPage,
    beforeEnter: authGuard,
    meta: { title: 'Blything | Admin', requiresAdmin: true },
  },
  {
    path: '/snail-mail',
    name: 'snailMail',
    component: SnailMailPage,
    alias: '/snailmail',
    meta: {
      title: 'Snail Mail',
      hideLoader: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFoundPage,
    meta: { title: 'Blything | Not Found' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(authGuardBeforeEach);

export default router;
